import styled from 'styled-components'

import mediaQueries from 'components/media-queries'
import e2eClasses from 'helpers/automation'

export const RefundInformation = styled.div.attrs(() => ({
  className: e2eClasses('corporate.refundInformation')
}))`
  margin: 50px 0;
  font-family: ${({ theme }) => theme.fonts.regular};
  color: ${({ theme }) => theme.colors.grayScorpion};
  font-size: 16px;
  ${mediaQueries.mobile`
    margin: 30px 0;
    font-size: 14px;
  `}
`

export const ListWrapper = styled.div.attrs(() => ({
  className: e2eClasses('corporate.refundList')
}))`
  padding: 10px 0 15px 0;
`
